import { State } from '../state';


export const technicalPages: State = {
    url: 'ops',
};

export const maintenance: State = {
    url: 'ops/maintenance'
};

export const unexpectedError: State = {
    url: 'unexpected-error'
};

export const accountDataRemoving: State = {
    url: 'ops/account-data-removing'
};

export const initialConfiguration: State = {
    url: 'ops/configure'
};

export const allegroAuth: State = {
    url: 'ops/allegro-auth'
};